import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import Featurelist from "../Feature/FeatureProductlist/Featurelist";
import sizeChart from "../../../assets/images/sizechart.jpeg";

// Dropdown Menu Component - UPDATED to handle size chart clicks
const DropdownMenu = ({ title, options, onSizeChartClick }) => {
	return (
		<li className="relative group font-poppins font-medium text-[15px]">
			<span className="flex items-center cursor-pointer py-2 px-3 text-black font-medium hover:text-[#1f4c94] transition-colors duration-200 uppercase tracking-wide">
				{title}
				<Icon
					icon="heroicons:chevron-down-20-solid"
					className="ml-1 h-4 w-4 transition-transform group-hover:rotate-180"
				/>
			</span>

			{/* Dropdown Content */}
			<div className="absolute left-1/2 -translate-x-1/2 mt-0 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-40 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 ease-in-out">
				<div className="py-1">
					{options.map((option, index) =>
						option.label === "Size Chart" ? (
							// Size Chart button - triggers modal
							<button
								key={index}
								onClick={() => onSizeChartClick(title)}
								className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#1f4c94] w-full text-center border-b border-gray-100 last:border-b-0 transition-colors duration-200">
								{option.label}
							</button>
						) : (
							// Regular navigation links
							<Link
								key={index}
								to={option.value}
								className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-[#1f4c94] w-full text-center border-b border-gray-100 last:border-b-0 transition-colors duration-200">
								{option.label}
							</Link>
						)
					)}
				</div>
			</div>
		</li>
	);
};

export default function Navbar() {
	const [isScrolled, setIsScrolled] = useState(false);
	const [showSearch, setShowSearch] = useState(false);
	const [showMenu, setShowMenu] = useState(false);
	const [showSizeChart, setShowSizeChart] = useState("");
	const [zoomed, setZoomed] = useState(false);
	const [isZoomActive, setIsZoomActive] = useState(false);
	const [zoomPosition, setZoomPosition] = useState({ x: 50, y: 50 });
	const imageRef = useRef(null);
	const [data, setdata] = useState([]);
	useEffect(() => {
		Promise.all([
			fetch("/data2025.json").then((res) => res.json()),
			fetch("/data2026.json").then((res) => res.json()),
		])
			.then(([prom2025, prom2026]) => {
				// ✅ Combine all three arrays into one
				const combinedData = [...prom2025, ...prom2026];
				setdata(combinedData);
			})
			.catch((error) => console.error("Error fetching data:", error));
	}, []);

	useEffect(() => {
		const handleScroll = () => setIsScrolled(window.scrollY > 50);
		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	const promOptions = [
		{ label: "2026 Collection", value: "/prom/2026" },
		{ label: "2025 Collection", value: "/prom/2025" },
		{ label: "Size Chart", value: "sizeChart" },
	];

	// Function to handle size chart clicks from dropdown
	const handleSizeChartClick = (category) => {
		setShowSizeChart(category);
	};

	// Zoom effect handlers for navbar modal
	const handleMouseMove = (e) => {
		if (!imageRef.current) return;

		const rect = imageRef.current.getBoundingClientRect();
		const x = (e.nativeEvent.offsetX / rect.width) * 100;
		const y = (e.nativeEvent.offsetY / rect.height) * 100;
		setZoomPosition({ x, y });
	};

	const handleMouseEnter = () => {
		setIsZoomActive(true);
	};

	const handleMouseLeave = () => {
		setIsZoomActive(false);
	};

	return (
		<>
			{/* Size Chart Modal - UPDATED with zoom effect */}
			{showSizeChart && (
				<div className="fixed inset-0 h-screen bg-black bg-opacity-70 flex items-center justify-center z-[10000] p-4">
					<div className="absolute top-4 right-4  gap-3 z-10 flex justify-between items-center">
						{/* Zoom Button */}
						<button
							onClick={() => setZoomed((prev) => !prev)}
							className="bg-white/10 hover:bg-white/20 text-white p-2 rounded-full transition">
							<Icon
								icon={
									zoomed
										? "mdi:magnify-minus-outline"
										: "mdi:magnify-plus-outline"
								}
								className="w-7 h-7"
							/>
						</button>

						{/* Close Button */}
						<button
							onClick={() => {
								setShowSizeChart("");
								setZoomed(false);
								setIsZoomActive(false);
							}}
							className="bg-white/10 hover:bg-white/20 text-white p-2 rounded-full transition">
							<Icon icon="heroicons:x-mark-20-solid" className="w-7 h-7" />
						</button>
					</div>
					<div className="w-full bg-transparent  flex flex-col justify-center items-center gap-5 relative">
						{/* Top Buttons */}

						{/* Image Container */}
						<div
							className={`w-[100%] h-full max-h-[90vh] overflow-x-auto overflow-y-hidden flex justify-center ${
								zoomed ? "cursor-grab" : ""
							}`}>
							{/* Zoomable Image */}
							<div
								ref={imageRef}
								className="w-[70%]  max-h-[600px]  relative overflow-hidden rounded-2xl bg-gray-50"
								style={{}}
								onMouseMove={handleMouseMove}
								onMouseEnter={handleMouseEnter}
								onMouseLeave={handleMouseLeave}>
								{/* Main Image */}
								<img
									src={
										showSizeChart === "PROM"
											? sizeChart
											: showSizeChart === "BRIDAL"
											? "https://lightskyblue-wombat-982521.hostingersite.com/wp-content/uploads/2024/07/Enchanted-BRIDAL-SIZE-CHART-scaled.jpg"
											: showSizeChart === "EVENING"
											? "https://lightskyblue-wombat-982521.hostingersite.com/wp-content/uploads/2024/07/Enchanted-MOB-SIZE-CHART-scaled.jpg"
											: ""
									}
									alt={`${showSizeChart} Size Chart`}
									className={`transition-transform duration-300 w-full h-full object-contain px-5 ${
										zoomed ? "scale-110" : "scale-100"
									}`}
									style={{
										transformOrigin: "center center",
										minWidth: zoomed ? "130%" : "auto",
									}}
								/>

								{/* Zoom Overlay */}
								<div
									className="absolute inset-0 transition-opacity duration-300"
									style={{
										opacity: isZoomActive && !zoomed ? 1 : 0,
										backgroundImage: `url(${
											showSizeChart === "PROM"
												? sizeChart
												: showSizeChart === "BRIDAL"
												? "https://lightskyblue-wombat-982521.hostingersite.com/wp-content/uploads/2024/07/Enchanted-BRIDAL-SIZE-CHART-scaled.jpg"
												: showSizeChart === "EVENING"
												? "https://lightskyblue-wombat-982521.hostingersite.com/wp-content/uploads/2024/07/Enchanted-MOB-SIZE-CHART-scaled.jpg"
												: ""
										})`,
										backgroundSize: "200%",
										backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
										pointerEvents: "none",
									}}
								/>
								<div
									className={`absolute bottom-4 right-4 bg-blue-600 text-white w-[50px] flex items-center justify-center px-0 py-[14px] rounded-full text-sm transition-all duration-300 ${
										isZoomActive && !zoomed ? "opacity-100" : "opacity-0"
									}`}>
									<Icon icon="iconamoon:zoom-in-light" width="20" height="20" />
								</div>
							</div>

							{/* Zoom Icon */}
						</div>
					</div>
				</div>
			)}

			{/* Navbar */}
			<div
				className={`fixed left-0 w-full z-50 transition-all duration-500 ${
					isScrolled ? "top-[-52px]" : "top-0"
				}`}>
				{/* Top Black Bar */}
				<div
					className={`flex justify-between  items-center bg-[#1f4c94] w-full px-5 py-3 transition-all duration-500 ${
						isScrolled
							? "opacity-0 pointer-events-none -translate-y-4 scale-95"
							: "opacity-100 translate-y-0 scale-100"
					}`}>
					<Link to="https://www.instagram.com/azuredress?igsh=MXhoNzZ2N3hqbjgyeA==" target="_blank">
						<Icon
							icon="ri:instagram-fill"
							width="22"
							height="22"
							className="text-white hover:text-gray-300 transition"
						/>
					</Link>
					{/* Social Media Icons */}
					<div className="hidden gap-3 items-center ">
						<Icon
							icon="akar-icons:facebook-fill"
							width="20"
							height="20"
							className="text-white hover:text-gray-300 transition"
						/>

						<Icon
							icon="iconoir:tiktok-solid"
							width="22"
							height="22"
							className="text-white hover:text-gray-300 transition"
						/>
					</div>

					{/* User Actions */}
					<div className="flex items-center gap-3">
						<button onClick={() => setShowSearch(true)}>
							<Icon icon="bx:search-alt" width="24" height="24" color="white" />
						</button>
					</div>
				</div>

				{/* Main Navigation */}
				<div
					className={`bg-white transition-all duration-500 ease-in-out border-b border-gray-100 ${
						isScrolled ? "shadow-lg py-5 " : "py-6"
					}`}>
					<div className="flex md:justify-center justify-between items-center px-4">
						<div className="block md:hidden" onClick={() => setShowMenu(true)}>
							<Icon icon="hugeicons:menu-09" width="35" height="35" />
						</div>
						<div className="cursor-pointer font-americana font-extrabold text-center">
							<h2 className="text-4xl bg-gradient-to-r from-[#3A7BD5] via-[#8A2BE2] to-[#00D2FF] bg-clip-text text-transparent">
								Azure
							</h2>
							<span className="text-[10px] uppercase tracking-[3px] text-gray-600 mt-2 block group-hover:text-[#3A7BD5] transition-colors">
								Proudly Canadian
							</span>
						</div>

						<div className="flex items-center gap-3 md:hidden">
							<button onClick={() => setShowSearch(true)}>
								<Icon
									icon="bx:search-alt"
									width="24"
									height="24"
									color="black"
								/>
							</button>
						</div>
					</div>

					{/* Navigation Menu */}
					<div className="pt-3 pb-3 hidden md:block">
						<ul className="hidden md:flex font-poppins justify-center items-center gap-8 flex-wrap ">
							<li>
								<Link
									to="/"
									className="text-black font-medium hover:text-[#1f4c94] py-2 px-3">
									HOME
								</Link>
							</li>
							{/* UPDATED: Added onSizeChartClick prop */}
							<DropdownMenu
								title="PROM"
								options={promOptions}
								onSizeChartClick={handleSizeChartClick}
							/>

							<li>
								<Link
									to="/about"
									className="text-black font-medium hover:text-[#1f4c94] py-2 px-3">
									ABOUT US
								</Link>
							</li>
							<li>
								<Link
									to="/contact"
									className="text-black font-medium hover:text-[#1f4c94] py-2 px-3">
									CONTACT
								</Link>
							</li>
							<li className="border-[2px] border-[#1f4c94] p-2 rounded-md text-[#1f4c94] hover:bg-[#1f4c94] hover:text-white transition">
								<Link
									to="https://market.azuredress.com/"
									className="flex items-center gap-1transition">
									<span className="text-sm font-semibold	 ">RETAILER LOGIN</span>
								</Link>
							</li>
						</ul>
					</div>
				</div>
			</div>

			{/* Modals */}
			<SearchModal
				show={showSearch}
				onClose={() => setShowSearch(false)}
				data={data}
			/>
			<MenuModal show={showMenu} onClose={() => setShowMenu(false)} />
		</>
	);
}

// Rest of your SearchModal and MenuModal components remain the same...
function SearchModal({ show, onClose, data }) {
	const [searchTerm, setSearchTerm] = useState("");
	// Filter data when searchTerm length >= 3
	const filteredResults =
		searchTerm?.length >= 3
			? data?.filter((item) =>
					item.style?.toLowerCase()?.includes(searchTerm?.toLowerCase())
			  )
			: [];

	console.log(filteredResults);

	return (
		<div
			className={`fixed inset-0 bg-white z-[1000] flex flex-col items-center justify-start pt-20 transition-all duration-500 ease-in-out ${
				show ? "opacity-100 visible" : "opacity-0 invisible"
			}`}>
			{/* Close button */}
			<div className="absolute top-6 right-6">
				<button
					onClick={onClose}
					className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition">
					<Icon
						icon="system-uicons:cross"
						width="35"
						height="35"
						color="#000"
					/>
				</button>
			</div>

			{/* Search input */}
			{data?.length > 0 ? (
				<div className="w-[90%] md:w-[60%] lg:w-[40%] flex items-center gap-3 border-b-2 border-gray-400 pb-2 mb-6">
					<Icon icon="bx:search-alt" width="30" height="30" color="black" />
					<input
						type="text"
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
						placeholder="Search here..."
						className="w-full outline-none text-lg font-medium"
					/>
				</div>
			) : (
				<p className="text-gray-500">Loading...</p>
			)}

			{/* Results */}
			<div
				style={{
					scrollbarWidth: "thin",
					scrollbarColor: "#1f4c94",
				}}
				className="w-[90%] md:w-[70%] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 overflow-y-auto max-h-[80vh] pb-10">
				{filteredResults.length > 0 ? (
					filteredResults.map((item) => (
						<Featurelist key={item.id} data={item} />
					))
				) : searchTerm.length >= 3 ? (
					<p className="text-gray-500 text-center w-full">No results found.</p>
				) : (
					<p className="text-gray-400 text-center w-full">
						Type at least 3 letters to search
					</p>
				)}
			</div>
		</div>
	);
}

function MenuModal({ show, onClose }) {
	const promOptions = [
		{ label: "2026 Collection", value: "/prom/2026" },
		{ label: "2025 Collection", value: "/prom/2025" },
		{ label: "Size Chart", value: "sizeChart" },
	];

	const [openDropdown, setOpenDropdown] = useState(null);
	const [showSizeChart, setShowSizeChart] = useState("");
	const [zoomed, setZoomed] = useState(false);
	const [isZoomActive, setIsZoomActive] = useState(false);
	const [zoomPosition, setZoomPosition] = useState({ x: 50, y: 50 });
	const imageRef = useRef(null);

	const toggleDropdown = (menuName) => {
		setOpenDropdown(openDropdown === menuName ? null : menuName);
	};

	const handleNavigate = (optionValue) => {
		if (optionValue === "sizeChart") {
			setShowSizeChart("Prom");
		} else {
			onClose();
			// Navigation would be handled by Link component
		}
	};

	const handleMouseMove = (e) => {
		if (!imageRef.current) return;

		const rect = imageRef.current.getBoundingClientRect();
		const x = ((e.clientX - rect.left) / rect.width) * 100;
		const y = ((e.clientY - rect.top) / rect.height) * 100;
		setZoomPosition({ x, y });
	};

	const handleMouseEnter = () => {
		setIsZoomActive(true);
	};

	const handleMouseLeave = () => {
		setIsZoomActive(false);
	};

	return (
		<>
			{/* Size Chart Modal */}
			{showSizeChart && (
				<div className="fixed inset-0 h-screen bg-black bg-opacity-70 flex items-center justify-center z-[1200] p-4">
					{/* Close Button */}
					<button
						onClick={() => setShowSizeChart("")}
						className="absolute top-3 right-3 text-gray-200 hover:text-blue-600 transition z-10">
						<Icon icon="heroicons:x-mark-20-solid" className="w-7 h-7" />
					</button>

					{/* Zoom Toggle Button */}
					<button
						onClick={() => setZoomed((prev) => !prev)}
						className="absolute top-3 left-3 text-gray-200 hover:text-blue-600 transition z-10">
						<Icon
							icon={
								zoomed
									? "mdi:magnify-minus-outline"
									: "mdi:magnify-plus-outline"
							}
							className="w-7 h-7"
						/>
					</button>

					<div className="bg-transparent w-full flex flex-col justify-center items-center gap-5 relative">
						{/* Image Container */}
						<div
							className={`w-full h-full max-h-[90vh] overflow-auto flex justify-center items-start ${
								zoomed ? "cursor-grab" : ""
							}`}>
							{/* Zoomable Image Container */}
							<div
								ref={imageRef}
								className="relative overflow-hidden rounded-2xl bg-gray-50"
								onMouseMove={handleMouseMove}
								onMouseEnter={handleMouseEnter}
								onMouseLeave={handleMouseLeave}
								style={{
									width: zoomed ? "200%" : "100%",
									height: zoomed ? "auto" : "500px",
									transition: "all 0.3s ease",
								}}>
								{/* Main Image */}
								<img
									src={sizeChart}
									alt="Prom Size Chart"
									className="w-full h-full object-contain"
								/>

								{/* Zoom Overlay - Only show when zoom is active and not fully zoomed */}
								{!zoomed && (
									<div
										className="absolute inset-0 transition-opacity duration-300"
										style={{
											opacity: isZoomActive ? 1 : 0,
											backgroundImage: `url(${sizeChart})`,
											backgroundSize: "200%",
											backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
											pointerEvents: "none",
										}}
									/>
								)}
							</div>

							{/* Zoom Icon */}
							<div
								className={`absolute bottom-4 right-4 bg-blue-600 text-white w-[50px] h-[50px] flex items-center justify-center rounded-full text-sm transition-all duration-300 ${
									isZoomActive && !zoomed ? "opacity-100" : "opacity-0"
								}`}>
								<Icon icon="iconamoon:zoom-in-light" width="20" height="20" />
							</div>
						</div>
					</div>
				</div>
			)}

			{/* Main Menu Modal */}
			<div
				className={`fixed top-0 left-0 h-full w-[80%] md:w-[40%] bg-white shadow-2xl z-[1000] transition-transform duration-500 ease-in-out ${
					show ? "translate-x-0" : "-translate-x-full"
				}`}>
				<div className="flex justify-between items-center px-5 py-4 border-b">
					<h2 className="text-lg font-semibold">Menu</h2>
					<button
						onClick={onClose}
						className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition">
						<Icon icon="si:close-duotone" width="35" height="35" color="#000" />
					</button>
				</div>

				<ul className="flex flex-col gap-4 mt-5 px-4 font-poppins text-[16px] font-medium text-black">
					<li className="px-2">
						<Link to="/" onClick={onClose}>
							HOME
						</Link>
					</li>

					<li className="px-2">
						<button
							onClick={() => toggleDropdown("prom")}
							className="flex items-center gap-2 font-medium hover:text-[#1f4c94] w-full text-left">
							Prom
							<Icon
								icon={
									openDropdown === "prom"
										? "akar-icons:chevron-up"
										: "akar-icons:chevron-down"
								}
							/>
						</button>
						{openDropdown === "prom" && (
							<ul className="ml-5 mt-2 flex flex-col gap-4">
								{promOptions.map((item, index) => (
									<li key={index} className="hover:text-[#1f4c94] text-black">
										{item.value === "sizeChart" ? (
											<button
												onClick={() => handleNavigate(item.value)}
												className="w-full text-left hover:text-[#1f4c94]">
												{item.label}
											</button>
										) : (
											<Link to={item.value} onClick={onClose}>
												{item.label}
											</Link>
										)}
									</li>
								))}
							</ul>
						)}
					</li>

					<li className="px-2">
						<Link to="/about" onClick={onClose}>
							ABOUT US
						</Link>
					</li>
					<li className="px-2">
						<Link to="/contact" onClick={onClose}>
							CONTACT
						</Link>
					</li>
					<li>
						<Link
							to="https://market.azuredress.com/"
							className="flex items-center gap-1 bg-[#1f4c94] text-white px-2 py-3 hover:text-gray-300 transition"
							onClick={onClose}>
							<span className="font-medium">RETAILER LOGIN</span>
						</Link>
					</li>
				</ul>
			</div>
		</>
	);
}
